import axios from "axios";
import {
  FETCH_FACEBOOK_USER_URL,
  FETCH_GOOGLE_USER_URL,
  GET_ACCESS_TOKEN_URL,
  LOGIN_URL,
  LOGOUT_URL,
  PROXY_URL,
  SIGNUP_URL,
} from "../constants/url.constants";
import { serviceAPI, serviceAPIJSON } from "./service";
import { handleErrorResponse, handleInfoResponse } from "../actions/message";
import { isNullUndefined } from "../util/util";
import { store } from "../store";
import { logout } from "../actions/auth";
import history from "../helpers/history";
import { LOGIN_SUCCESS } from "../actions/type";

class AuthService {
  login(username, password) {
    return serviceAPI
      .post(LOGIN_URL, { username, password })
      .then((response) => {
        const localTimeAtReception = Date.now();
        if (response.status === 200) {
          let user = response.data.user;
          //bind this to the user for future requests
          user.subscriptionStatusCd = response.data.subscriptionStatusCd;
          user.refreshToken = window.btoa(response.data.user.refreshToken);
          const serverTimeAtIssuance = user.issuedAt; // This is the Long from server

          // difference between server's time and the user's clock
          const clockSkew = serverTimeAtIssuance - localTimeAtReception;
          localStorage.setItem("clock_skew", clockSkew);

          localStorage.setItem("user", JSON.stringify(user));
          response.data.user = user;
        }
        return response.data;
      })
      .catch((error) => {
        handleErrorResponse(error)
      });
  }

	getAccessToken() {
		let user = JSON.parse(localStorage.getItem('user'));
		let refreshToken = '';
		if (!isNullUndefined(user) && !isNullUndefined(user.refreshToken)) {
			refreshToken = window.atob(user.refreshToken);
			return serviceAPI
				.post(GET_ACCESS_TOKEN_URL, { refreshToken })
				.then((response) => {
					const localTimeAtReception = Date.now();
					const newUser = response.data.user;
					if (response.status === 200) {
						newUser.proxyRole = user.proxyRole;
						newUser.proxyFacility = user.proxyFacility;
						newUser.proxySubscription = user.proxySubscription;
						newUser.isProxy = user.isProxy;
						newUser.services = user.services;

						newUser.refreshToken = window.btoa(response.data.user.refreshToken);
						const serverTimeAtIssuance = newUser.issuedAt; // This is the Long from server

            // difference between server's time and the user's clock
            const clockSkew = serverTimeAtIssuance - localTimeAtReception;
            localStorage.setItem("clock_skew", clockSkew);

            localStorage.setItem("user", JSON.stringify(newUser));
            response.data.user = newUser;

            store.dispatch({
              type: LOGIN_SUCCESS,
              payload: { user: newUser },
            });
            window.location.reload();
          } else {
            store.dispatch(logout());
          }
          return response.data;
        })
        .catch((error) => {
          store.dispatch(logout());
          history.push("/");
          handleErrorResponse(error);
        });
    }
  }

  fetchFacebookUser(id) {
    return axios
      .post(FETCH_FACEBOOK_USER_URL, { id })
      .then((response) => {
        if (response.status === 200) {
          let user = response.data.user;
          //bind this to the user for future requests
          localStorage.setItem("user", JSON.stringify(user));
        }
        return response.data;
      })
      .catch((error) => {
        handleErrorResponse(error);
      });
  }

  fetchGoogleUser(id) {
    return axios
      .post(FETCH_GOOGLE_USER_URL, { id })
      .then((response) => {
        if (response.status === 200) {
          let user = response.data.user;
          //bind this to the user for future requests
          localStorage.setItem("user", JSON.stringify(user));
        }
        return response.data;
      })
      .catch((error) => {
        handleErrorResponse(error);
      });
  }

  logout() {
    const localUser = JSON.parse(localStorage.getItem("user"));
    const clearAuth = () => {
      localStorage.clear();
    };

    if (!localUser) {
      clearAuth();
      return Promise.resolve();
    }

    return serviceAPI
      .post(LOGOUT_URL, { userId: localUser.userId, loginType: "KODI" })
      .then((response) => {
        clearAuth();
        handleInfoResponse(response.data);
      })
      .catch((error) => {
        clearAuth();
        handleErrorResponse(error);
      });
  }

  register(username, email, password) {
    return axios.post(SIGNUP_URL, {
      username,
      email,
      password,
    });
  }

  executeProxy(params) {
    return serviceAPIJSON
      .post(PROXY_URL, params)
      .then((response) => {
        if (response.status === 200) {
          let proxyUser = response.data;
          let localUser = JSON.parse(localStorage.getItem("user"));
          localUser.proxyRole = proxyUser.proxyRole;
          localUser.proxyFacility = proxyUser.proxyFacility;
          localUser.proxySubscription = proxyUser.proxySubscription;
          localUser.services = proxyUser.services;
          localUser.roles = proxyUser.roles;
          localUser.permissions = proxyUser.permissions;
          localUser.isProxy = proxyUser.isProxy;
          localStorage.setItem("user", JSON.stringify(localUser));
          return proxyUser;
        }
      })
      .catch((error) => {
        handleErrorResponse(error);
      });
  }

  clearProxy() {
    let localUser = JSON.parse(localStorage.getItem("user"));
    localUser.proxyRole = "";
    localUser.proxyFacility = "";
    localUser.proxySubscription = "";
    localUser.isProxy = false;
    localUser.services = [];
    // localUser.permissions = []
    localStorage.setItem("user", JSON.stringify(localUser));
  }
}

export const emptyUser = {
  proxyRole: "",
  proxySubscription: "",
  proxyFacility: "",
  jwt: "",
  isProxy: false,
  permissions: [],
  roles: [],
  services: [],
  userId: "",
};
const authService = new AuthService();
export default authService;
